module.exports = __webpack_public_path__ + "img/noodles-2.dce8975e.jpg";